const OUTPUT_ATTRIBUTE_DATA_TYPES = {
  DECIMAL: 'decimal',
  INTEGER: 'integer',
  STRING: 'string',
};

export const OUTPUT_ATTRIBUTE_DEFAULT_EXPRESSION_BY_DATA_TYPE = {
  [OUTPUT_ATTRIBUTE_DATA_TYPES.DECIMAL]: [1],
  [OUTPUT_ATTRIBUTE_DATA_TYPES.INTEGER]: [1],
  [OUTPUT_ATTRIBUTE_DATA_TYPES.STRING]: [],
};
